module.exports = __webpack_public_path__ + "img/not_found.654a022e.svg";